import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default function EmailNotificationList() {
    // Use toast
    const toast = useToast();

    const refUserListTable = ref(null);

    // Table Handlers
    const tableColumns = [
        { key: "select", sortable: false, label: "Select" },
        { key: "name", sortable: true, label: "Name" },
        { key: "type", sortable: true, label: "Type" },
        { key: "status", sortable: true, label: "Status" },
        { key: "is_mandatory", sortable: true, label: "mandatory" },
        { key: "actions" }
    ];
    const perPage = ref(10);
    const totalEmailNotificationList = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref("");
    const sortBy = ref("id");
    const isSortDirDesc = ref(true);
    const statusFilter = ref(null);
    const typeFilter = ref(null);
    const emailNotificationsMetaData = ref([]);
    const emailNotificationStatusOption = ref([]);
    const emailNotificationTypeOption = ref([]);

    const dataMeta = computed(() => {
        const localItemsCount = refUserListTable.value
            ? refUserListTable.value.localItems.length
            : 0;
        return {
            from:
                perPage.value * (currentPage.value - 1) +
                (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalEmailNotificationList.value
        };
    });

    const refetchData = () => {
        refUserListTable.value.refresh();
    };

    watch(
        [
            currentPage,
            perPage,
            searchQuery,
            statusFilter,
            typeFilter,
        ],
        () => {
            refetchData();
        }
    );

    const fetchEmailNotificationList = (ctx, callback) => {
        store
            .dispatch("app-email-notifications/fetchEmailNotifications", {
                q: searchQuery.value,
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,
                status: statusFilter.value,
                type: typeFilter.value,
            })
            .then(response => {
                const email_notification = response.data.data;
                const { total } = response.data.meta;
                emailNotificationStatusOption.value = response.data.status;
                emailNotificationTypeOption.value = response.data.type;

                callback(email_notification);
                totalEmailNotificationList.value = total;
                emailNotificationsMetaData.value = email_notification;
            })
            .catch(error => {
                console.error(error);
                // toast({
                //     component: ToastificationContent,
                //     props: {
                //         title: "Error fetching email-notifications",
                //         icon: "AlertTriangleIcon",
                //         variant: "danger"
                //     }
                // });

                toast({
                    component: ToastificationContent,
                    props: {
                      title: `Error fetching email-notifications`,
                      icon:'AlertTriangleIcon',
                      variant : 'danger',
                      hideClose: true,
                      
                    },
                      },
                      {
                    timeout : 3000,
                    position : 'bottom-center',
                    toastClassName:"error-info",
                    hideProgressBar : true,
                      })
            });
    };

    const resolveUserStatusVariant = status => {
        if (status == false) return "danger";
        if (status == true) return "success";
        return "primary";
    };

    return {
        fetchEmailNotificationList,
        tableColumns,
        perPage,
        currentPage,
        totalEmailNotificationList,
        emailNotificationsMetaData,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refUserListTable,
        refetchData,
        resolveUserStatusVariant,
        emailNotificationStatusOption,
        statusFilter,
        emailNotificationTypeOption,
        typeFilter
    };
}
